export enum ClientSideSecrets {
  BC_ACCOUNT_ID = "BC_ACCOUNT_ID",
  FB_API_KEY = "FB_API_KEY",
  FB_VAPID_KEY = "FB_VAPID_KEY",
}
